import React from "react";

const HeroContent = () => {
  return (
    <div className="hero_content">
      <div>
        <h2>all about giving you the best burger experience </h2>
        <button>order now</button>
      </div>
    </div>
  );
};

export default HeroContent;
